<template>
  <Spinner v-if="transactionStore.isLoading || topPageStore.isLoading" />
  <div id="bst-wrap">
    <div class="l-project-wrap l-project-wrap--mypage">

      <Header />

      <section class="l-content-area">
        <div class="l-content">

          <!-- MYPAGE -->
          <section class="p-bloc p-bloc--mypage">
            <div class="p-bloc__content l-wrap__outer">
              <div class="l-wrap__inner">

                <section class="p-mypage">

                  <!-- Mypage Menu -->
                  <NavbarMyPage />
                  <!-- Side Menu -->
                  <SideMenu />

                  <!-- Mypage Content -->
                  <div class="p-mypage__content">
                    <div class="mypage-content">

                      <!-- transaction -->
                      <div class="p-mypage__usage p-mypage__usage--transaction mypage-bloc">
                        <div class="mypage-bloc__head">
                          <h2>{{ $t('LABEL_TRANSACTION_HISTORY') }}</h2>
                        </div>
                        <div class="mypage-bloc__content">

                          <!-- search -->
                          <search class="usage__search usage__search--transaction">
                            <div class="search__select">
                              <select id="select-merchant" v-model="transactionStore.companyAppId" class="form-select"
                                aria-label="Default select example">
                                <option :value="''" :selected="null">{{ $t("COLUMN_SITE_NAME") }}</option>
                                <option v-for="(companyApp, index) in topPageStore.registeredApps" :key="index"
                                  :value="companyApp.company_app_id">{{ companyApp.site_name }}</option>
                              </select>
                            </div>
                            <div class="search__ui">
                              <ul class="search__date">
                                <li class="calendar">
                                    <VueDatePicker id="date-from-transaction" locale="ja" type="date" name="start-date" :placeholder="$t('LABEL_DATE_PLACEHOLDER')"
                                    v-model="transactionStore.dateFrom" :enable-time-picker="false" :format="format" :auto-apply="true" />
                                </li>
                                <li class="hyphen">-</li>
                                <li class="calendar"><VueDatePicker id="date-to-transaction" locale="ja" type="date" name="end-date" :placeholder="$t('LABEL_DATE_PLACEHOLDER')"
                                    v-model="transactionStore.dateTo" :enable-time-picker="false" :format="format" :auto-apply="true" /></li>
                              </ul>
                              <div class="search__btn">
                                <button id="btn-clear-transaction" class="c-btn__clear" type="reset" v-on:click="clear">{{ $t('LABEL_BUTTON_CLEAR_SEARCH') }}</button>
                                <button id="btn-search-transaction" class="c-btn__search" @click="searchTransactions(1)">{{ $t('LABEL_BUTTON_SEARCH') }}</button>
                              </div>
                            </div>
                          </search>

                          <!-- transaction list -->
                          <div class="usage__list usage__list--transaction">
                            <div class="usage__empty" v-if="transactionStore.transactions.length < 1">
                                <h2>{{ $t('TEXT_RECORDS_NOT_FOUND') }}</h2>
                                <p>{{ $t('TEXT_TRANSACTIONS_NOT_FOUND') }}</p>
                            </div>
                            <Transactions v-if="transactionStore.transactions.length > 0" v-bind:transactions="transactionStore.transactions" />
                          </div>
                          <div class="usage__paging">
                            <Paginator v-model="transactionStore.page" :length="transactionStore.totalPages"
                              @update:modelValue="searchTransactions" v-if="transactionStore.transactions.length > 0" />
                          </div>

                        </div>
                      </div>

                    </div><!-- .mypage-content -->
                  </div>

                </section>

              </div>
            </div>
          </section>


        </div><!-- .l-content -->
      </section><!-- .l-content-area -->

    </div><!-- .l-project-wrap -->

    <Footer />

  </div>
</template>

<script setup>
import NavbarMyPage from "@/components/NavbarMyPage.vue";
import Footer from "@/components/Footer.vue";
import SideMenu from "@/components/SideMenu.vue";
import Header from "@/components/Header.vue";
import Transactions from "@/components/Transactions.vue";
import Paginator from "@/components/Paginator.vue";
import { onBeforeMount } from "vue";
import Spinner from "@/components/Spinner.vue";
import { useTopPageStore } from "@/stores/topPageStore";
import { useTransactionStore } from "@/stores/transactionStore";
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'

const format = (date) => {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${year}-${month}-${day}`;
}

const topPageStore = useTopPageStore();
const transactionStore = useTransactionStore();

onBeforeMount(async () => {
    await topPageStore.getTopPageData();
    await transactionStore.getTransactions(1);
});

async function searchTransactions(page) {
    transactionStore.page = page;
    await transactionStore.getTransactions(page);
}

async function clear() {
    transactionStore.companyAppId = '';
    transactionStore.dateFrom = null;
    transactionStore.dateTo = null;

    transactionStore.page = 1;
    await transactionStore.getTransactions(1);
}
</script>